import i18next from 'i18next'
import { TypeCastingValidator } from './safe-type-casting'

export type TranslationApiData = {
  Language: string
  Translation: string
}[]

export const translationValidator: TypeCastingValidator<TranslationApiData> = {
  kind: 'array',
  elementValidator: {
    kind: 'object',
    fieldsValidator: {
      Language: { kind: 'string' },
      Translation: { kind: 'string' },
    },
  },
}

export const getTranslation = (data: TranslationApiData) => {
  const translation = data.find(
    (translation) => translation.Language === i18next.language
  )
  return translation ? translation.Translation : ''
}
